/*
Copied from https://github.com/draft-js-plugins/draft-js-plugins/tree/master/packages/mention
*/

export default function getTypeByTrigger(trigger: string): string {
  return trigger === '{{' ? 'mention' : `${trigger}mention`
}
